// extracted by mini-css-extract-plugin
export default {"NewsPage":"NewsPage_NewsPage__bxUr6","button_wrapper":"NewsPage_button_wrapper__DUaLS"};